module.exports = __webpack_public_path__ + "static/media/react.b404398f.png";